/* eslint-disable @typescript-eslint/naming-convention */
import { ModelValidationMetadataMap } from 'app/core/validation';

export const adminValidationMetadata: ModelValidationMetadataMap = {
  Admin: {
    validators: [
      {
        group: 'appointment',
        validators: ['onlyOneSingleAppointmentType'],
      },
    ],
    properties: {
      shortName: {
        displayName: 'Job Code',
        required: true
      },
      name: {
        displayName: 'Job Name',
        required:  true
      }
    }
  },
  AppointeeAppointment: {
    properties: {
      user: {
        displayName: 'Appointee Name',
        validators: [
          {
            group: 'appointment',
            validators: ['required'],
          },
        ],
      },
    },
  },
  Appointment: {
    properties: {
      // eslint-disable-next-line id-blacklist
      number: {
        displayName: 'Appointee Number',
        validators: [
          {
            group: 'appointment',
            validators: ['unique'],
          },
        ],
      },
      appointmentType: {
        displayName: 'Appointment Type',
        validators: [
          {
            group: 'appointment',
            validators: ['required'],
          },
        ],
      },
    },
  },
};
